import { useEffect, useState } from 'react'
import { sendGet } from '../../hooks/use-fetch'
import { useAccountId } from '../../ContextProviders/CurrentAccount'
import { AccountType } from '../../core/types'
import SimpleAccordion from '../Accordian'
import { Button } from '@mui/material'
import S3Image from '../S3Image'
import { EnrollmentEdit } from '../../Pages/Enrollments/EnrollmentEdit'

interface ServiceItem {
  id: number
  name: string
  s3Key: string | null
}

export interface NewServiceSelectionProps {
  isdID?: number | null
  childID: number | null
}

export function NewServiceSelection (props: NewServiceSelectionProps): JSX.Element {
  const [serviceList, setServiceList] = useState<ServiceItem[] | null>()
  const [selectedService, setSelectedService] = useState<ServiceItem | null>(null)
  const [isdID, setIsdID] = useState<number | null>(props.isdID ?? null)
  const account = useAccountId()

  useEffect(() => {
    const loadFormData = async (): Promise<void> => {
      let currentISD: number
      let spId: number | null = null
      if (account?.type === AccountType.ISD) {
        setIsdID(account.id)
        currentISD = account.id
      } else if (account?.type === AccountType.INTAKE_USER) {
        currentISD = account.currentISDID ?? 0
        setIsdID(currentISD)
      } else {
        currentISD = props.isdID ?? 0
        spId = account?.id ?? null
      }
      const { response: services } = await sendGet(`/ISDServices/GetCurrentServices?ISDID=${currentISD}${(spId != null ? `&spId=${spId}` : '')}`, {})
      setServiceList(services)
    }
    void loadFormData()
  }, [account])

  const serviceClick = (service: ServiceItem): void => {
    setSelectedService(service)
  }

  const onHide = (): void => {
    setSelectedService(null)
  }

  return <> <SimpleAccordion title='Create New Service' icon={<></>} width='300px' className=''
    sx={{
      borderRadius: '16px !important',
      '.MuiAccordionSummary-root': {
        backgroundColor: 'gainsboro',
        minHeight: '50px !important',
        height: '50px',
        flexDirection: 'row-reverse' // this puts the toggle button on the left side
      }
    }}
    body={<>
      {serviceList == null
        ? <p>No services available.</p>
        : serviceList?.map((service) => (
          <div key={service.id}>
            <Button variant='text' onClick={() => { serviceClick(service) }}>
              {(service.s3Key ?? '') !== '' && <S3Image imageKey={service.s3Key ?? ''} style={{ height: '30px', width: '30px' }} />}
              {service.name}
            </Button>
          </div>
        ))}
    </>}
  />
    {selectedService != null && account != null && isdID != null && <EnrollmentEdit
      childId={props.childID}
      isdId={isdID}
      enrollmentId={null}
      serviceProviderId={account.id}
      serviceId={selectedService.id}
      serviceS3Key={selectedService.s3Key}
      show={true}
      restrictedEdit={false}
      onClose={onHide}
    />
    }
  </>
}
